import { AuthStorageKeys } from '@utils/localStorageAuthUtils.utils';
import {
  retrieveConnectionDetailsFromAuthConfig,
  ZID_CLIENT_ID,
  ZID_SCOPE,
  ZidAuthSessionStorageKeys,
  ZidAuthUrlParams,
} from './tokenUtils';

const ZID_AUTHORIZATION_PATH = '/oauth2/v1/authorize';

const generateRandomString = (length: number): string => {
  const array = new Uint32Array(length / 2);
  window.crypto.getRandomValues(array);
  return Array.from(array, dec => `0${dec.toString(16)}`.slice(-2)).join('');
};

export const signInWithRedirect = async (options?: { customState?: string; postLoginPath?: string }): Promise<void> => {
  try {
    const authConfigStr = localStorage.getItem(AuthStorageKeys.authConfig);
    if (!authConfigStr) {
      throw new Error('Authentication configuration not found. Please configure your connection.');
    }

    const { zidTenantServiceDomain, insecure } = retrieveConnectionDetailsFromAuthConfig();

    const state = generateRandomString(40);

    sessionStorage.setItem(ZidAuthSessionStorageKeys.oauthState, state);

    const finalRedirectPath = options?.postLoginPath || window.location.pathname;
    sessionStorage.setItem(ZidAuthSessionStorageKeys.postLoginRedirectPath, finalRedirectPath);

    if (options?.customState) {
      sessionStorage.setItem(ZidAuthSessionStorageKeys.customState, options.customState);
    }

    const params = new URLSearchParams({
      client_id: ZID_CLIENT_ID,
      response_type: ZidAuthUrlParams.code,
      redirect_uri: `${window.location.origin}`,
      scope: ZID_SCOPE,
      state,
    });

    window.location.href = `${insecure ? 'http' : 'https'}://${zidTenantServiceDomain}${ZID_AUTHORIZATION_PATH}?${params.toString()}`;
  } catch (e) {
    throw new Error(`Could not start the sign-in process. ${e instanceof Error ? e.message : String(e)}`);
  }
};
